import { get, reduce, uniq } from 'lodash';

/* globals Raven */

/**
 * Check if cart has multiple promotions with same code
 *
 * @param {ICart} cart
 * @param {boolean} receivedFromNetwork - determine whether the data comes from the network or the store
 * @param {string} api - API endpoint
 * @return {boolean}
 */
export default function checkDuplicatedPromotions(cart, receivedFromNetwork = false, api = null) {
    if (!get(cart, 'promotions', null)) {
        return false;
    }

    const { promotions } = cart;

    const hasDuplicatedPromos = checkPromotions(promotions);

    if (!hasDuplicatedPromos) {
        return false;
    }

    if (typeof Raven !== 'undefined') {
        Raven.captureException(new Error('multi-promotion-error'), {
            extra: {
                cart,
                receivedFromNetwork,
                api,
            },
        });
    }

    return true;
}

/**
 * Check promotion collection
 *
 * @param {Object[]} promotions
 * @return {boolean}
 */
export function checkPromotions(promotions) {
    const promotionNames = reduce(promotions, (names, promotion) => {
        names.push(promotion.code);
        return names;
    }, []);
    const uniquePromotionNames = uniq(promotionNames);
    return (uniquePromotionNames.length !== promotionNames.length);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/debug/promotion-code-logger.js